import React from 'react';
import CasinoContainer from '../../../../components/casino/CasinoContainer';
import TgCasinoContent from './TgCasinoContent';

export default function TgCasino() {
  return (
    <CasinoContainer title={'Telegram casino'}>
      <TgCasinoContent />
    </CasinoContainer>
  );
}
